import { render, staticRenderFns } from "./candidatesTable.vue?vue&type=template&id=e6329254&scoped=true&"
import script from "./candidatesTable.vue?vue&type=script&lang=js&"
export * from "./candidatesTable.vue?vue&type=script&lang=js&"
import style0 from "./candidatesTable.vue?vue&type=style&index=0&id=e6329254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6329254",
  null
  
)

export default component.exports